import { BRANCHES, CLIENTS } from '../constants';
import { FetchAPI } from '../Main/fetchAPI';
import { BranchClientProperties, ClientBranchProperties } from './branchProperties';

export const BranchClient = {
	getBranches: (id: string) =>
		FetchAPI.getJson({
			urlStr: `${CLIENTS}/${id}/branches`,
		}),
	addClientToBranch: (data: ClientBranchProperties) =>
		FetchAPI.postJson({
			urlStr: `${CLIENTS}/${data.clientId}/branches`,
			data,
		}),
	addBranchToClient: (data: BranchClientProperties) =>
		FetchAPI.postJson({
			urlStr: `${BRANCHES}/${data.branchId}/clients`,
			data,
		}),
};
